import firebase from "firebase";

const state = {};

const actions = {
  updateDoc({state},{ doc, action, data}){
    state;
    const db = firebase.firestore();
    return new Promise((resolve, reject) => {
      if( action == "delete" ){
        db.doc(doc)[action]().then( ref => {
          resolve(ref)
        }).catch( err => {
          reject(err)
        })
      }
      else{

        let now = firebase.firestore.Timestamp.fromDate(new Date());
        data.updated = now;
        delete data.bound;
        db.doc(doc)[action](data).then( ref => {
          resolve(ref)
        }).catch( err => {
          reject(err)
        })
      }
    })
  }, 
  addDoc({state},{ collection, data}){
    state;
    const db = firebase.firestore();
    return new Promise((resolve, reject) => {
      let now = firebase.firestore.Timestamp.fromDate(new Date());
      data.created = now;
      data.updated = now;
      db.collection(collection).add(data).then( ref => {
        resolve(ref)
      }).catch( err => {
        reject(err)
      })
    })
  },
  getDoc({state},{ doc }){
    state;
    const db = firebase.firestore();
    return new Promise((resolve, reject) => {
      db.doc(doc).get().then( ref => {
        if( !ref.exists ){
          resolve(false);
        }
        let result = ref.data();
        result.id = ref.id;
        resolve(result)
      }).catch( err => {
        reject(err)
      })
    })
  }
};

const mutations = {};


export default {
  state,
  actions,
  mutations,
};

